import angular from 'angular';
import template from './kform-html-element.html';

const kformHtmlElementDirective = /* @ngInject */ (
	/** @type {import('angular').sanitize.ISanitizeService} */ $sanitize,
) => ({
	restrict: 'E',
	scope: {
		component: '=',
	},
	template,
	link: (/** @type {any} */ $scope) => {
		if ($scope.options && $scope.options.building) {
			return;
		}
		const displayError = (/** @type {string} */ message) => {
			$scope.parseError = `Invalid HTML: ${ message.toString()}`;
		};

		$scope.$watch('component', () => {
			if (!$scope.component.tag) {
				return displayError('No tag given');
			}

			const element = angular.element(`<${$scope.component.tag}>${$scope.component.content}</${$scope.component.tag}>`);

			// Add the css classes if supplied.
			if ($scope.component.className) {
				element.attr('class', $scope.component.className);
			}

			for (const attribute of $scope.component.attrs) {
				if (attribute.attr) {
					element.attr(attribute.attr, attribute.value);
				}
			}

			try {
				$scope.html = $sanitize(element.prop('outerHTML'));
				$scope.parseError = null;

				// If the sanitized html is empty, it was invalid; Create a visible error so we still render something.
				if (!$scope.html) {
					return displayError(element.prop('outerHTML'));
				}
			}
			catch (/** @type {any} */ error) {
				// Isolate the message and store it.
				$scope.parseError = error.message
					.split('\n')[0]
					.replace('[$sanitize:badparse]', '');
			}
			return true;
		}, true);
	},
});

export default kformHtmlElementDirective;
